/**
 * Initialize event handlers for tabs showing/hiding.
 *
 * @example
 * ```
 * <script>
 *     // Configuration for popular and recent tabs (show/hide capability).
 *     const tabLinks                  =       '.js-tab-links';
 *     const tabs                      =       '.js-tabs';
 *     initTabListeners( tabLinks, tabs);
 * </script>
 *
 * <body>
 *      <li>
 *          <a class="js-tab-links active" data-target-id="recent-posts" href="#recent-posts">Most Recent</a>
 *      </li>
 *      <li>
 *          <a class="js-tab-links" data-target-id="popular-posts" href="#popular-posts">Most Popular</a>
 *      </li>
 *
 *      <div id="recent-posts" class="js-tabs">
 *          <p>Foo</p>
 *      </div>
 *      <div id="popular-posts" class="js-tabs d-none">
 *          <p>Bar</p>
 *      </div>
 * </body>
 *
 * ```
 *
 *
 * @param {string} tabLinks  classname for querying all tabLinks.
 * @param {string} tabs      classname for querying all tabs.
 */
export default function initTabListeners( tabLinks, tabs ) {
    const nodes     =   document.querySelectorAll( tabLinks );
    const tabNodes  =   document.querySelectorAll( tabs );
    for( let i=0, len = nodes.length ; i < len; i++ ) {

        nodes[i].addEventListener( 'click', function( e ) {
            triggerIntegratePremiumLock();
            for( let j=0, len = nodes.length ; j < len; ++j ) {
                if ( e.currentTarget === nodes[j] && !nodes[j].classList.contains( 'active' ) ) {
                    nodes[j].classList.add( 'active' );
                    openTab( nodes[j].dataset.targetId, tabNodes );
                } else {
                    nodes[j].classList.remove( 'active' );
                }
            }

        });
    }
}

 /**
  * Opens a target tab node and hides the others.
  *
  * @param {string}      openingTabId      Target tab ID that will be shown.
  * @param {NodeList}    tabNodes          All HTML nodes that are tabs to be shown/hidden.
  */
function openTab( openingTabId, tabNodes ) {
    for( let i=0, len = tabNodes.length ; i < len; i++ ) {
        if ( openingTabId === tabNodes[i].id && tabNodes[i].classList.contains( 'd-none' ) ) {
            tabNodes[i].classList.toggle( 'd-none' );
        } else {
            tabNodes[i].classList.add( 'd-none' );
        }
    }
}
